// START add save modal + email validation
function initExpiviSaveModal() {
  const saveBtn = document.getElementById('saveDesignBtn');
  const modal = document.getElementById('save-modal-wrapper');
  const thumbnail = document.getElementById('saveModalThumbnail');
  const attributeList = document.getElementById('saveModalAttributes');
  const cancelBtn = document.getElementById('cancelSaveModal');
  const closeBtn = document.getElementById('closeSaveModal');
  const confirmBtn = document.getElementById('confirmSaveModal');
  const emailInput = document.getElementById('saveModalEmail');
  const nameInput = document.getElementById('saveModalName');
  const hiddenUrl = document.getElementById('saveModalPageUrl');

  if (!saveBtn || !modal || !thumbnail || !attributeList || !emailInput || !nameInput) {
    console.warn('🔁 Retry: Modal elements not ready, will try again...');
    setTimeout(initExpiviSaveModal, 300);
    return;
  }

  const footer = document.querySelector('.save-modal-footer');
    if (footer && !document.querySelector('.save-modal-privacy')) {
      const privacyText = document.createElement('span');
      privacyText.className = 'save-modal-privacy';
      privacyText.textContent = 'Mit dem Klick auf den Button akzeptierst du unsere Datenschutzbestimmungen.';
      footer.insertBefore(privacyText, footer.firstChild);
    }

  // Stricter email validator (requires a dot-TLD, no spaces)
  const EMAIL_RE = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

  function isValidEmail(email) {
    return EMAIL_RE.test(email.trim());
  }

  // Optional: also enforce via native validation
  if (emailInput) {
    emailInput.setAttribute('type', 'email'); // in case markup isn't
    emailInput.setAttribute('pattern', EMAIL_RE.source);
  }


  // Reset Save button state
  function resetConfirmButton() {
    confirmBtn.disabled = false;
    confirmBtn.innerHTML = 'Save';
  }

  // Close modal with animation
  function closeModal() {
    modal.classList.remove('show');
    modal.classList.add('hide');
    setTimeout(() => {
      modal.style.display = 'none';
      modal.classList.remove('hide');
      resetConfirmButton();
    }, 300); // match CSS transition time
  }

  // Click outside modal closes it
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });

  // ESC key closes modal
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.style.display === 'flex') {
      closeModal();
    }
  });

  // Global save click handler
  window.handleMoonaSaveClick = function () {
    console.log("🧠 handleMoonaSaveClick triggered");
    if (typeof expivi?.saveConfiguration === 'function') {
      Promise.all([
        expivi.saveConfiguration(0, 0),
        expivi.getScreenshot(640, 360)
      ]).then(([configJson, screenshot]) => {
        configJson.thumbnail = screenshot;
        window._latestConfigJson = configJson;

        // Strip ?configuration=... from URL if present
        const url = new URL(window.location.href);
        url.searchParams.delete('configuration');
        hiddenUrl.value = url.toString();

        window.showSaveModal(configJson);
      }).catch(err => console.error('❌ Error saving configuration or screenshot:', err));
    } else {
      alert('Expivi is not ready yet.');
    }
  };

  // Button bindings
  saveBtn.addEventListener('click', window.handleMoonaSaveClick);
  cancelBtn.onclick = closeModal;
  closeBtn.onclick = closeModal;

  confirmBtn.onclick = () => {
    const email = emailInput.value.trim();
    const fullName = nameInput.value.trim();
    const configJson = window._latestConfigJson;

    if (!fullName) {
      alert("Please enter your full name.");
      nameInput.focus();
      return;
    }
    if (!email) {
      alert("Please enter your email address.");
      emailInput.focus();
      return;
    }
    if (!isValidEmail(email)) {
      alert("Please enter a valid email address.");
      emailInput.focus();
      return;
    }
    if (!configJson) {
      alert("Configuration data is missing.");
      return;
    }

    // Disable button & show spinner
    confirmBtn.disabled = true;
    confirmBtn.innerHTML = `<span class="spinner" style="
      border: 2px solid #fff;
      border-top: 2px solid transparent;
      border-radius: 50%;
      width: 14px;
      height: 14px;
      display: inline-block;
      margin-right: 8px;
      animation: spin 0.6s linear infinite;
      vertical-align: middle;"></span> Saving...`;

    // Strip the thumbnail field
    const { thumbnail, ...configWithoutThumbnail } = configJson;

    const payload = {
      name: fullName,
      email: email,
      page_url: hiddenUrl.value,
      configuration: configWithoutThumbnail
    };

    // Send to Make.com
    fetch('https://hook.eu2.make.com/gftu1udejovvma2zl1rz9osm1rendrgy', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(response => {
      console.log('📤 Sent to Make.com:', response.status);
      setTimeout(() => {
        confirmBtn.innerHTML = 'Gespeichert!';
        // Auto-close after 3s
        setTimeout(() => {
          closeModal();
        }, 3000);
      }, 1000);
    }).catch(error => {
      console.error('❌ Error sending to Make.com:', error);
      resetConfirmButton();
    });
  };

  // Show modal
  window.showSaveModal = function (configJson) {
    const attributes = Array.isArray(configJson.attributes) ? configJson.attributes : [];

    if (!configJson.thumbnail) {
      console.warn('⚠️ Thumbnail missing in configJson');
      thumbnail.style.display = 'none';
    } else {
      thumbnail.style.display = 'block';
      thumbnail.src = configJson.thumbnail;
    }

    attributeList.innerHTML = attributes
      .map(attr => `<li><strong>${attr.attribute_name}:</strong> ${attr.attribute_value_name}</li>`)
      .join('');

    modal.classList.add('show');
    modal.style.display = 'flex';
    resetConfirmButton();
  };
}


// Spinner animation
const style = document.createElement('style');
style.innerHTML = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}`;
document.head.appendChild(style);

setTimeout(initExpiviSaveModal, 500);

/*
document.addEventListener('DOMContentLoaded', function() {
  const urlField = document.getElementById('saveModalPageUrl');
  if (urlField) {
    urlField.value = window.location.href;
  }
}); */

// === Load saved config from URL if exists ===
document.addEventListener('DOMContentLoaded', function () {
  window.expivi._events.onChange.subscribe(function (e) {
    if (e.name === "fully_loaded") {
      const urlParams = new URLSearchParams(window.location.search);
      const configId = urlParams.get('configuration');

      if (!configId) {
        //console.log("[XPV] No configuration ID in URL.");
        return;
      }

      const configUrl = `https://product-configurator.ams3.digitaloceanspaces.com/moona/${configId}.json`;
      console.log(`[XPV] Loading config from: ${configUrl}`);

      fetch(configUrl)
        .then(response => {
          if (!response.ok) throw new Error(`[XPV] Fetch failed: ${response.status}`);
          return response.json();
        })
        .then(config => {
          expivi.loadConfiguration(config);
          console.log("[XPV] Configuration loaded successfully.");
        })
        .catch(err => {
          console.error("[XPV] Error loading saved configuration:", err);
        });
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const proxyButton = document.getElementById('xpv-atc-button');

  if (proxyButton) {
    proxyButton.addEventListener('click', function () {
      const realButton = document.querySelector('.expivi-add-to-cart.expivi-custom-button.to-cart-center');
      if (realButton) {
        realButton.click();
      } else {
        console.warn('[XPV] Real add to cart button not found.');
      }
    });
  } else {
    console.warn('[XPV] Proxy ATC button not found.');
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const atcBtn = document.getElementById('xpv-atc-button');

  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      const spinner = atcBtn.querySelector('.spinner');
      const label = atcBtn.querySelector('.label');

      // Disable button
      atcBtn.disabled = true;

      // Show spinner
      if (spinner) spinner.style.display = 'inline-block';

      // Optional: Keep label or change it
      // label.textContent = 'Adding...';

      // Re-enable button after process (simulate 2s delay for demo)
      setTimeout(() => {
        atcBtn.disabled = false;
        if (spinner) spinner.style.display = 'none';
      }, 2000);
    });
  }
});


var expiviPriceTimeout;

function updateEpxiviPrice() {
  clearTimeout(expiviPriceTimeout);

  expiviPriceTimeout = setTimeout(function () {
    expivi.getPrice().then(function (price) {
      const numericPrice = parseFloat(price);
      if (isNaN(numericPrice)) {
        console.warn('[XPV] Invalid price:', price);
        return;
      }

      const markupPrice = numericPrice / 0.5;

      function formatPrice(value) {
        return Math.round(value).toLocaleString('de-DE');
      }

      const priceElements = document.querySelectorAll('.moona-price-value .price');
      if (priceElements.length) {
        priceElements.forEach(el => el.textContent = formatPrice(numericPrice));
      } else {
        console.warn('[XPV] .price elements not found.');
      }

      const originalPriceElements = document.querySelectorAll('.moona-price-value .original-price');
      if (originalPriceElements.length) {
        originalPriceElements.forEach(el => el.textContent = formatPrice(markupPrice));
      } else {
        console.warn('[XPV] .original-price elements not found.');
      }

    }).catch(function (error) {
      console.error('[XPV] Error fetching price:', error);
    });
  }, 1000);
}




expivi._events.onChange.subscribe(function(event) {
  if (event.name === 'attribute') {
	updateEpxiviPrice();
  }
});

(function() {
  var path = location.pathname.toLowerCase();
  var hasConfigurator = path.indexOf('/apps/configurator') !== -1 || path.indexOf('configurator') !== -1;
  var params = new URLSearchParams(location.search);
  var hasModel = params.has('model') && params.get('model').trim() !== '';

  if (hasConfigurator && hasModel) {
    var style = document.createElement('style');
    style.type = 'text/css';
    style.textContent = 'div[data-xpv-key="headboardID"]{display:none!important;}';
    document.head.appendChild(style);
  }
})();

// START add ui icons (Moona)
(function initMoonaUiIcons() {
  const CONTAINER_SELECTOR = '.viewer-container';
  const RETRY_MS = 300;
  let tries = 0;

  function ensureReady() {
    const container = document.querySelector(CONTAINER_SELECTOR);
    const expiviReady = !!(window.expivi && window.expivi.setProductAttributeByKey);

    if (!container || !expiviReady) {
      if (tries < 60) { // ~18s max
        tries++;
        setTimeout(ensureReady, RETRY_MS);
      } else {
        console.warn('[XPV] UI icons: viewer container or Expivi not ready.');
      }
      return;
    }

    mountUi(container);
    wireArProxy();
    syncInitialState();
    observeConfigChanges();
  }

  function mountUi(container) {
    var locale = (new URLSearchParams(window.location.search).get('locale') || 'de').toLowerCase();
    var isEN = locale.startsWith('en');

    var labels = {
      fullscreen:   isEN ? 'Full Screen'            : 'Full-Screen',
      bg:           isEN ? 'Bedroom View'           : 'Schlafzimmer-Ansicht',
      ar:           isEN ? 'Place in Room'          : '3D ins Zimmer stellen',
      savedesign:   isEN ? 'Save Design'            : 'Entwurf speichern',
      sample:       isEN ? '5 Free Fabric Samples'  : '5 kostenlose Stoffmuster'
    };

    const wrapper = document.createElement('div');
    wrapper.className = 'iconsUI';
    wrapper.innerHTML = [
      '<button type="button" class="xpv-ui-btn" id="fullscreenButton">',
      '  <span class="xpv-ui-btn__label">' + labels.fullscreen + '</span>',
      '</button>',

      '<button type="button" class="xpv-ui-btn" id="bgButton" aria-pressed="false" aria-label="Toggle Environment">',
      '  <span class="xpv-ui-btn__label">' + labels.bg + '</span>',
      '  <span class="ui-options">',
      '    <span class="ui-option" data-value="mat-env-1">Umgebung 1</span>',
      '    <span class="ui-option" data-value="mat-env-2">Umgebung 2</span>',
      '  </span>',
      '</button>',

      '<button type="button" class="xpv-ui-btn" id="arButton" aria-label="Open Augmented Reality">',
      '  <span class="xpv-ui-btn__label">' + labels.ar + '</span>',
      '</button>',

      '<button type="button" class="xpv-ui-btn" id="saveDesignBtnUi">',
      '  <span class="xpv-ui-btn__label">' + labels.savedesign + '</span>',
      '</button>',

      '<button type="button" class="xpv-ui-btn" id="sampleButton">',
      '  <span class="xpv-ui-btn__label">' + labels.sample + '</span>',
      '</button>'
    ].join('');

    container.appendChild(wrapper);

    const bgBtn = document.getElementById('bgButton');
    const arBtn = document.getElementById('arButton');
    const options = bgBtn.querySelectorAll('.ui-option');

    bgBtn?.addEventListener('click', () => {
      backgroundSwitcher();
      updateOptionHighlight();
    });

    options.forEach(opt => {
      opt.addEventListener('click', (e) => {
        e.stopPropagation();
        const value = opt.getAttribute('data-value');
        window.expivi?.setProductAttributeByKey?.('att-env-type', value);
        updateOptionHighlight();
      });
    });

    [bgBtn, arBtn].forEach(btn => {
      btn?.addEventListener('keydown', (e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          btn.click();
        }
      });
    });

    document.getElementById('fullscreenButton')?.addEventListener('click', function() {
      document.getElementById('xpv-toolbar-item-fullscreen')?.click();
    });

    document.getElementById('saveDesignBtnUi')?.addEventListener('click', function() {
      if (typeof window.handleMoonaSaveClick === 'function') {
        window.handleMoonaSaveClick();
      }
    });

    document.getElementById('sampleButton')?.addEventListener('click', function() {
      window.open('https://enjoy-schlafsysteme.de', '_blank');
    });

    updateOptionHighlight();
  }

  function wireArProxy() {
    const arBtn = document.getElementById('arButton');
    arBtn?.addEventListener('click', () => {
      // Always disable Umgebung before AR
      window.expivi?.setProductAttributeByKey?.('att-env', 'att-env-off');
      setButtonState('bgButton', false);
      updateOptionHighlight();

      setTimeout(() => {
        const real = document.getElementById('xpv-toolbar-item-web-ar');
        if (real) {
          real.click();
        } else {
          console.warn('[XPV] AR toolbar item not found.');
        }
      }, 200);
    });
  }

  function syncInitialState() {
    setButtonState(
      'bgButton',
      isAttributeOn('att-env', 'att-env-on')
    );
    updateOptionHighlight();
  }

  function observeConfigChanges() {
    try {
      window.expivi?._events?.onChange?.subscribe?.((e) => {
        if (e?.name === 'configuration') {
          syncInitialState();
        }
      });
    } catch (_) {}
  }

  function isAttributeOn(key, onValueKey) {
    try {
      const current = window.expivi?.getProductAttributeByKey?.(key);
      if (current && typeof current.valueKey === 'string') {
        return current.valueKey === onValueKey;
      }
    } catch (_) {}
    return false;
  }

  function getAttributeValueKey(key) {
    try {
      const current = window.expivi?.getProductAttributeByKey?.(key);
      if (current && typeof current.valueKey === 'string') return current.valueKey;
    } catch (_) {}
    return null;
  }

  function setButtonState(id, isOn) {
    const el = document.getElementById(id);
    if (!el) return;
    el.classList.toggle('xpv-ui-btn-active', !!isOn);
    el.setAttribute('aria-pressed', !!isOn);
  }

  // Only show .ui-option-active when att-env === att-env-on
  function updateOptionHighlight() {
    const envOn = isAttributeOn('att-env', 'att-env-on');
    const currentType = getAttributeValueKey('att-env-type'); // 'mat-env-1' | 'mat-env-2' | null
    const options = document.querySelectorAll('#bgButton .ui-option');

    options.forEach(o => o.classList.remove('ui-option-active'));

    if (!envOn) return; // nothing highlighted when OFF

    // If env is ON, highlight the option matching att-env-type (fallback to first)
    let toHighlight = null;
    if (currentType) {
      toHighlight = Array.from(options).find(o => o.getAttribute('data-value') === currentType);
    }
    (toHighlight || options[0])?.classList.add('ui-option-active');
  }

  document.addEventListener('DOMContentLoaded', ensureReady);
})();
// END add ui icons (Moona)


// START ui button functions (Moona)
let backgroundSwitch = false;
function backgroundSwitcher() {
  backgroundSwitch = !backgroundSwitch;
  const btn = document.getElementById('bgButton');

  if (backgroundSwitch) {
    window.expivi?.setProductAttributeByKey?.('att-env', 'att-env-on');
  } else {
    window.expivi?.setProductAttributeByKey?.('att-env', 'att-env-off');
  }

  btn?.classList.toggle('ui-button-active', backgroundSwitch);
  btn?.setAttribute('aria-pressed', backgroundSwitch);
  btn?.blur();
}
// END ui button functions (Moona)

// NAVIGATION TABS 

(function initStepProgress() {
  function getOrCreateBar() {
    let bar = document.getElementById('moona-step-progress');
    if (!bar) {
      const nav = document.querySelector('.v-slide-group:not([role=tablist])');
      if (!nav) return null;
      const track = document.createElement('div');
      track.id = 'moona-step-progress-track';
      bar = document.createElement('div');
      bar.id = 'moona-step-progress';
      track.appendChild(bar);
      nav.appendChild(track);
    }
    return bar;
  }

  function updateProgress() {
    const buttons = Array.from(document.querySelectorAll('.v-slide-group__content .v-btn'));
    const active = document.querySelector('.v-slide-group__content .v-btn.v-slide-item--active');
    const bar = getOrCreateBar();
    if (!buttons.length || !active || !bar) return;
    const index = buttons.indexOf(active);
    const percent = ((index + 1) / buttons.length) * 100;
    bar.style.width = percent + '%';
  }

  const observer = new MutationObserver(updateProgress);
  function initObserver() {
    const content = document.querySelector('.v-slide-group__content');
    if (!content) { setTimeout(initObserver, 300); return; }
    updateProgress();
    observer.observe(content, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('DOMContentLoaded', initObserver);
})();
// END NAVIGATION TABS

// NEXT STEP BUTTON

(function initXpvNextStepButton() {
  function getButtons() {
    return Array.from(document.querySelectorAll('.v-slide-group__content .v-btn'));
  }

  function getActiveIndex(buttons) {
    return buttons.findIndex(b => b.classList.contains('v-slide-item--active'));
  }

  function updateButton() {
    const btn = document.getElementById('xpv-next-step-btn');
    if (!btn) return;

    const buttons = getButtons();
    const idx = getActiveIndex(buttons);

    if (idx === -1) {
      btn.style.display = 'none';
      return;
    }

    if (idx >= buttons.length - 1) {
      btn.style.display = 'inline-flex';
      btn.classList.add('xpv-final-step');
      btn.querySelector('.xpv-next-label').textContent = 'Warenkorb';
      return;
    }

    btn.classList.remove('xpv-final-step');
    const nextLabel = buttons[idx + 1].querySelector('.v-btn__content')?.textContent?.trim();
    btn.style.display = 'inline-flex';
    btn.querySelector('.xpv-next-label').textContent = `Weiter zu ${nextLabel} >`;
  }

  function handleClick() {
    const buttons = getButtons();
    const idx = getActiveIndex(buttons);

    if (idx >= buttons.length - 1) {
      const btn = document.getElementById('xpv-next-step-btn');
      const spinner = btn?.querySelector('.spinner');

      if (btn) btn.disabled = true;
      if (spinner) spinner.style.display = 'inline-block';

      setTimeout(() => {
        if (btn) btn.disabled = false;
        if (spinner) spinner.style.display = 'none';
      }, 2000);

      document.querySelector('.expivi-add-to-cart.expivi-custom-button.to-cart-center')?.click();
      return;
    }

    if (idx > -1) {
      buttons[idx + 1].click();
      setTimeout(updateButton, 0);
    }
  }

  function init() {
    const btn = document.getElementById('xpv-next-step-btn');
    if (!btn) { setTimeout(init, 300); return; }

    btn.addEventListener('click', handleClick);

    function waitForContent() {
      const content = document.querySelector('.v-slide-group__content');
      if (!content) { setTimeout(waitForContent, 300); return; }
      const observer = new MutationObserver(updateButton);
      observer.observe(content, { subtree: true, attributes: true, attributeFilter: ['class'] });
      updateButton();
    }
    waitForContent();
  }

  document.addEventListener('DOMContentLoaded', init);
})();

// END NEXT STEP BUTTON


// START XPV TOOLTIPS

(function initXpvTooltips() {

  var INFO_SVG = '<span class="xpv-info-icon-label">i</span>';

  function stripRichContent(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    ['img', 'iframe', 'video', 'figure', 'picture', 'source', 'table', 'thead', 'tbody', 'tr', 'td', 'th'].forEach(function(tag) {
      tmp.querySelectorAll(tag).forEach(function(el) { el.remove(); });
    });
    return tmp.innerHTML;
  }

  function createIcon(key, type) {
    var btn = document.createElement('span');
    btn.role = 'button';
    btn.tabIndex = 0;
    btn.className = 'xpv-info-icon';
    btn.setAttribute('data-tooltip-key', key);
    btn.setAttribute('data-tooltip-type', type);
    btn.innerHTML = INFO_SVG;

    if (type === 'tooltip-a') {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        openModal(key);
      });
      btn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModal(key); }
      });
    } else if (type === 'tooltip-b') {
      btn.addEventListener('mouseenter', function() {
        openFloat(key, btn);
      });
      btn.addEventListener('mouseleave', function() {
        closeFloat();
      });
    }

    return btn;
  }

  function openModal(key) {
    var entry = XpvTooltipMap[key];
    if (!entry) return;
    document.getElementById('xpv-tooltip-content').innerHTML = entry.content;
    document.getElementById('xpv-tooltip-wrapper').classList.add('show');
  }

  function closeModal() {
    document.getElementById('xpv-tooltip-wrapper').classList.remove('show');
    document.getElementById('xpv-tooltip-content').innerHTML = '';
  }

  function openFloat(key, anchor) {
    var entry = XpvTooltipMap[key];
    if (!entry) return;

    var float = document.getElementById('xpv-tooltip-float');
    float.innerHTML = stripRichContent(entry.content);
    float.style.display = 'block';

    var rect = anchor.getBoundingClientRect();
    var floatHeight = 300;
    var spaceBelow = window.innerHeight - rect.bottom;
    var spaceAbove = rect.top;

    var leftPos = rect.left;
    var floatWidth = 300;
    var margin = 100;

    if (leftPos + floatWidth > window.innerWidth - margin) {
      leftPos = window.innerWidth - floatWidth - margin;
    }
    if (leftPos < margin) {
      leftPos = margin;
    }

    float.style.left = leftPos + 'px';
    float.style.bottom = 'auto';
    float.style.top = 'auto';

    if (spaceBelow >= floatHeight || spaceBelow >= spaceAbove) {
      float.style.top = (rect.bottom + window.scrollY + 6) + 'px';
    } else {
      float.style.top = (rect.top + window.scrollY - floatHeight - 6) + 'px';
    }
  }

  function closeFloat() {
    var float = document.getElementById('xpv-tooltip-float');
    float.style.display = 'none';
    float.innerHTML = '';
  }

  function injectIcons() {
    if (!window.XpvTooltipMap) return;

    document.querySelectorAll('[data-xpv-key]').forEach(function(container) {
      var key = container.getAttribute('data-xpv-key');
      var entry = XpvTooltipMap[key];
      if (!entry) return;
      if (container.querySelector('.xpv-info-icon')) return;

      var label = container.querySelector('p.text-gray-600');
      if (!label) return;

      var icon = createIcon(key, entry.type);
      label.style.display = 'inline-flex';
      label.style.alignItems = 'center';
      label.style.gap = '6px';
      label.appendChild(icon);
    });

    document.querySelectorAll('[data-option-key]').forEach(function(btn) {
      var key = btn.getAttribute('data-option-key');
      var entry = XpvTooltipMap[key];
      if (!entry) return;
      if (btn.querySelector('.xpv-info-icon')) return;

      var label = btn.querySelector('.xpv-option-label');
      if (!label) return;

      var icon = createIcon(key, entry.type);
      label.style.display = 'inline-flex';
      label.style.alignItems = 'center';
      label.style.gap = '6px';
      label.appendChild(icon);
    });
  }

  function init() {
    var wrapper = document.getElementById('xpv-tooltip-wrapper');
    if (wrapper) {
      wrapper.addEventListener('click', function(e) {
        if (e.target === wrapper) closeModal();
      });
    }

    var closeBtn = document.getElementById('xpv-tooltip-close');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeModal();
    });

    function waitForExpivi() {
      if (!window.expivi || !window.expivi._events) {
        setTimeout(waitForExpivi, 300);
        return;
      }

      window.expivi._events.onChange.subscribe(function(e) {
        if (e.name === 'fully_loaded') {
          injectIcons();
        }
      });

      function initStepObserver() {
        var container = document.querySelector('.v-window__container');
        if (!container) {
          setTimeout(initStepObserver, 300);
          return;
        }
        var observer = new MutationObserver(injectIcons);
        observer.observe(container, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style', 'class']
        });
      }
      initStepObserver();
    }
    waitForExpivi();
  }

  document.addEventListener('DOMContentLoaded', init);

})();

// END XPV TOOLTIPS